module.exports = __webpack_public_path__ + "graph.png";